__turbopack_context__.v({
  "memorable": "memorable-module-scss-module__ocD4xW__memorable",
  "memorable__experience": "memorable-module-scss-module__ocD4xW__memorable__experience",
  "memorable__moving-right": "memorable-module-scss-module__ocD4xW__memorable__moving-right",
  "memorable__star": "memorable-module-scss-module__ocD4xW__memorable__star",
  "memorable__title": "memorable-module-scss-module__ocD4xW__memorable__title",
});
